export default __webpack_public_path__ + "static/media/CI_TmaxEnterprise.71d29531.png";